import React from "react";
import { Box, IconButton, Stack, styled } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { customColors } from "models/customColors";
import { ReactComponent as SuccessIcon } from "images/success.svg";

const Container = styled(Stack)`
  position: fixed;
  top: 1rem;
  right: 1rem;
  margin-left: 1rem;
  min-width: 300px;
  max-width: 479px;

  display: flex;
  padding: 16px 58px 16px 16px;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  color: ${customColors.white};
  background-color: ${customColors.black};
  user-select: none;
  z-index: 10000;
`;

const IconContainer = styled(Stack)`
  justify-content: center;
  align-items: center;
`;

const Content = styled(Box)`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;
const CloseButton = styled(IconButton)`
  margin: 0.3rem;
  &:hover {
    background-color: ${customColors.grayText};
  }
`;
const CloseIcon = styled(Close)`
  fill: ${customColors.white};
`;

export const Notification = ({ warning, hideWarning }) => {
  if (!warning) return null;

  return (
    <Container>
      <Stack
        alignItems={"flex-end"}
        sx={{ margin: 0, position: "absolute", top: 0, right: 0 }}
      >
        <CloseButton
          size={"small"}
          aria-label="close"
          onClick={() => hideWarning()}
        >
          <CloseIcon fontSize="small" />
        </CloseButton>
      </Stack>

      <Stack direction={"row"} gap={"11px"}>
        <IconContainer>
          <SuccessIcon />
        </IconContainer>
        <Content>{warning}</Content>
      </Stack>
    </Container>
  );
};
